import { Component, OnInit } from '@angular/core';

import suneditor from 'suneditor'
import plugins from 'suneditor/src/plugins'
@Component({
  selector: 'app-suneditortest',
  templateUrl: './suneditortest.component.html',
  styleUrls: ['./suneditortest.component.css']
})
export class SuneditortestComponent implements OnInit {
   initEditor : any ;
  constructor() { }

  ngOnInit() {

    //const editor = suneditor.create((document.getElementById('sample') || 'sample'),{
      // All of the plugins are loaded in the "window.SUNEDITOR" object in dist/suneditor.min.js file
      // Insert options
      // Language global object (default: en)
     // lang: suneditor_LANG['ko']
  //});
//suneditor.init({
     this.initEditor = suneditor.create((document.getElementById('sample') || 'sample'),{
      plugins: plugins,     
      height: '200',
      width:'100%',
      fontSize : [   8,9,10,12,14,16,18,20,22,24,26,28,36,48 ],
    /*  buttonList: [
          ['undo', 'redo',
          'font', 'fontSize', 'formatBlock',
          'paragraphStyle', 
          'bold', 'underline', 'italic', 
          'fontColor', 'hiliteColor', 
          'removeFormat',
          'outdent', 'indent',
          'align', 'horizontalRule', 'list', 'lineHeight',
          'table', *'strike', 'textStyle', 'subscript', 'superscript','blockquote','link', 'image', 'video', 'audio',  'math', */ // You must add the 'katex' library at options to use the 'math' plugin.
          /** 'imageGallery',  // You must add the "imageGalleryUrl".
          'fullScreen', 'showBlocks', 'codeView',
          'preview', 'print', 'save', 'template'
        
        ]
      ]*/
      buttonList: [
        ['undo', 'redo','font', 'fontSize', 'bold', 'underline', 'italic',
         'removeFormat',  'list',  'outdent', 'indent','align',
     

        ]
      ]
  });
  }

  SetHTMLData()
  {
    this.initEditor.insertHTML('<span class="highlightText"> [[testdata]] </span>', true, true);

  }

}
